import { render, staticRenderFns } from "./ovrz1.vue?vue&type=template&id=28542a99&scoped=true"
import script from "./ovrz1.vue?vue&type=script&lang=js"
export * from "./ovrz1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28542a99",
  null
  
)

export default component.exports